const messages = {
	DEFAULT_ERROR: 'An error has occurred',
	AUTHORIZE_TOKEN_EXPIRED: 'Your session has expired. Please, login to the system to continue your work',
	AUTHORIZE_TOKEN_NOT_PROVIDED: 'Your session has expired. Please, login to the system to continue your work',
	PASSWORD_EXPIRED: 'Your Password has expired. Please, change your password to login to the system',
	AUTHORIZE_TOKEN_INVALID: 'Your authorization token is invalid. Please, try again',
};

export default (statusCode, errorCode, toastColor) => ({
	color: toastColor || (statusCode && statusCode < 400 ? 'success' : 'danger'),
	text: messages[errorCode] || messages.DEFAULT_ERROR,
});
